// eslint-disable-next-line
// @ts-nocheck
import _, { filter } from 'lodash';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import Box from '@mui/material/Box';
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Modal,
  Switch,
} from '@mui/material';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';
import SearchNotFound from '../../components/SearchNotFound';
import { BookingListToolbar } from '../../sections/@dashboard/bookings';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';
import {
  getServiceProviderDetails,
  getServiceProviderTotalRecords,
  setServiceProvider,
} from '../../store/state/serviceProviderSlice';
import {
  useGetAllServiceProviderDetailMutation,
  useDeleteServiceProviderDetailMutation,
  useSendStripeOnboardEmailMutation,
} from '../../store/api/serviceProviderApi';
import Loading from '../../components/Loading';
import toast from 'react-hot-toast';
import ArrowCircleDownOutlinedIcon from '@mui/icons-material/ArrowCircleDownOutlined';
import { styled } from '@mui/material/styles';
import { getMessage } from '../../components/message';
import {
  checkPermissions,
  onlyLastEmailShow,
  onlyLastFourNum,
} from '../../sections/@dashboard/parkingspaces/utility';
import { useForgotPasswordMutation } from '../../store/api/userApi';
import { PERMISSION } from '../../utils/userPermission';
import IconButton from '@mui/material/IconButton';
import LockResetIcon from '@mui/icons-material/LockReset';
import Tooltip from '@mui/material/Tooltip';

const TABLE_HEAD = [
  { id: 'name', label: 'Vendor Name', alignRight: false },
  { id: 'code', label: 'Vendor Code', alignRight: false },
  { id: 'emailId', label: 'Email Address', alignRight: false },
  { id: 'contactNumber', label: 'Phone Number', alignRight: false },
  // { id: 'DownloadAdhar', label: 'Download Aadhar Card ', alignRight: false },
  // { id: 'DownloadContract', label: 'Download Vendor Contract ', alignRight: false },
  { id: 'resetPassword', label: 'Reset Password', alignRight: false },
  // { id: ' SendStripeConnectLink', label: ' Send stripe connect link  ', alignRight: false },
  { id: 'VendorStatus', label: "Vendor's Status", alignRight: false },
];

const ResponsiveBox = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    flexDirection: 'column',
  },
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    flexDirection: 'row',
  },
}));

const MarginBox = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    marginTop: '10px',
    width: '100%',
  },
  [theme.breakpoints.up('md')]: {},
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

function capitalizeFirstLetter(string) {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
}


export default function VendorDetails() {
  const navigate = useNavigate();
  const [getAllServiceProviderDetail, serviceProviderResponse] = useGetAllServiceProviderDetailMutation();
  const [getAllServiceProviderDetailPending, serviceProviderPendingResponse] = useGetAllServiceProviderDetailMutation();
  const [deleteServiceProviderDetail, deleteResponse] = useDeleteServiceProviderDetailMutation();
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  const dispatch = useAppDispatch();
  const serviceProviderData = useAppSelector(getServiceProviderDetails);
  const serviceProviderTotalRecords = useAppSelector(getServiceProviderTotalRecords);
  const [serviceProviders, setServiceProviders] = useState([]);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [vendorId, setVendorId] = useState<number>();
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [pendingRequestCount, setPendingRequestCount] = useState(0);
  const [forgetPassword, forgetPasswordResponse] = useForgotPasswordMutation();
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - serviceProviders.length) : 0;
  const filteredUsers = serviceProviders;
  const isUserNotFound = filteredUsers.length === 0;
  const [serviceProviderId, serviceProviderNewIdResponse] = useSendStripeOnboardEmailMutation();

  useEffect(() => {
    if (serviceProviderData) {
      setServiceProviders(serviceProviderData);
    }
  }, [serviceProviderData]);

  useEffect(() => {
    getAllServiceProviderDetailPending({
      token: token.token,
      payload: { offset: rowsPerPage, page: page, orderBy: order, currentStatus: 'Pending' },
    });
  }, []);

  useEffect(() => {
    setFilterName('')
    getAllServiceProviderDetail({
      token: token.token,
      payload: { offset: rowsPerPage, page: page, orderBy: order, currentStatus: 'Approved' },
    });
  }, []);

  useEffect(() => {
    if (serviceProviderResponse.isSuccess) {
      dispatch(setServiceProvider(serviceProviderResponse.data));
    }

    if (serviceProviderResponse.isError) {
      let errorData: any = serviceProviderResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [serviceProviderResponse.isSuccess, serviceProviderResponse.isSuccess]);

  useEffect(() => {
    if (serviceProviderPendingResponse.isSuccess) {
      setPendingRequestCount(serviceProviderPendingResponse.data?.totalRecords);
    }

    if (serviceProviderPendingResponse.isError) {
      let errorData: any = serviceProviderPendingResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [serviceProviderPendingResponse.isSuccess, serviceProviderPendingResponse.isSuccess]);

  useEffect(() => {
    if (deleteResponse.isSuccess) {
      getAllServiceProviderDetail({
        token: token.token,
        payload: { offset: rowsPerPage, page: page, orderBy: order, currentStatus: 'Approved' },
      });
      toast.success('Vendor updated successfully.');
    }

    if (deleteResponse.isError) {
      let errorData: any = deleteResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [deleteResponse.isSuccess, deleteResponse.isError]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = serviceProviders.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllServiceProviderDetail({
      token: token.token,
      payload: { offset: rowsPerPage, page: newPage, currentStatus: 'Approved', orderBy: order },
    });
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getAllServiceProviderDetail({
      token: token.token,
      payload: { offset: parseInt(event.target.value, 10), page: 0, currentStatus: 'Approved', orderBy: order },
    });
  };

  const handleFilterByName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilterName(event.target.value);
      getAllServiceProviderDetail({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          vendorAlias: event.target.value,
          currentStatus: 'Approved',
          orderBy: order,
        },
      });
  };

  const handleDelete = () => {
    setOpen(false);
    deleteServiceProviderDetail({
      id: vendorId,
      token: token.token,
    });
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const cancelDelete = () => {
    setOpen(false);
  };

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '30px',
    px: '50px',
  };

  const handleClickChanges = (email: any) => {
    forgetPassword({
      email: email,
      category: 'UTSP',
    });
  };

  const handleClickSendLink = (id: any) => {
    serviceProviderId({
      token: token.token,
      serviceProviderId: id,
    });
    toast.success('Stripe Connect Link sent successfuly');
  };

  useEffect(() => {
    if (forgetPasswordResponse.isSuccess) {
      toast.success(getMessage.SUCCESS_FORGOT_PASSWORD);
    }

    if (forgetPasswordResponse.isError) {
      toast.error(getMessage.ERROR_FORGOT_PASSWORD);
    }
  }, [forgetPasswordResponse.isSuccess, forgetPasswordResponse.isError]);

  return (
    <Page title="Vendor Profile">
      {/* {checkPermissions(PERMISSION.VENDOR_ALL, token.permissions)?( */}
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={'25px'}>
          <Typography variant="h4" gutterBottom>
            Vendor Profile
          </Typography>
          {checkPermissions(PERMISSION.VENDOR_VIEW, token.permissions) ? null : (
            <ResponsiveBox>
              <Box>
                <Button
                  style={{
                    marginRight: '10px',
                    color: 'white',
                    backgroundColor: '#E23744',
                  }}
                  size="large"
                  variant="contained"
                  onClick={() => {
                    navigate('/dashboard/view-request');
                  }}
                >
                  View Requests ({pendingRequestCount})
                </Button>
              </Box>
              <MarginBox>
                <Button
                  variant="contained"
                  onClick={() => {
                    navigate('/dashboard/add-vendor', { state: { editMode: false } });
                  }}
                  startIcon={<Iconify icon="eva:plus-fill" />}
                  size="large"
                  style={{ color: 'white', backgroundColor: '#E23744' }}
                >
                  Add
                </Button>
              </MarginBox>
            </ResponsiveBox>
          )}
        </Stack>
        <Card>
          <BookingListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName}  placeholder={'Search Vendor Name'}/>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <AllParkingsListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={serviceProviders.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.length > 0 &&
                    filteredUsers.map((row) => {
                      const {
                        id,
                        vendorAlias,
                        name,
                        emailId,
                        contactNumber,
                        userId,
                        status,
                        tierType,
                        commission,
                        merchantId,
                        fileUrl,
                        contractFileUrl,
                        isStripeOnboarded,serviceProviders
                      } = row;
                      const isItemSelected = selected.indexOf(name) !== -1;
                      return (
                        <TableRow
                          hover
                          key={id.toString()}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell align="left">
                            <Typography
                              fontWeight="bold"
                              variant="subtitle2"
                              whiteSpace={'nowrap'}
                              style={{
                                color: 'blue',
                                cursor: 'pointer',
                              }}
                              onClick={() => {
                                navigate('/dashboard/add-vendor', {
                                  state: {
                                    id: id,
                                    merchantId: merchantId,
                                    commission: commission,
                                    tierType: tierType,
                                    userId: userId,
                                    editMode: true,
                                  },
                                });
                              }}
                            >
                              {name ? capitalizeFirstLetter(name) : capitalizeFirstLetter(name)}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="100" variant="subtitle2">
                              {vendorAlias ? capitalizeFirstLetter(vendorAlias) : capitalizeFirstLetter(name)}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="100" variant="subtitle2">
                              {checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions)
                                ? onlyLastEmailShow(emailId)
                                : emailId}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="100" variant="subtitle2">
                              {checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions)
                                ? onlyLastFourNum(contactNumber)
                                : contactNumber}
                            </Typography>
                          </TableCell>
                          {/* <TableCell align="left">
                            <Stack direction="row" justifyContent={'center'}>
                              <Button
                                style={{
                                  textDecoration: 'none',
                                  color:
                                    fileUrl === null ||
                                    checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions)
                                      ? 'lightgray'
                                      : 'blue',
                                  border: 'none',
                                  background: 'none',
                                }}
                                disabled={
                                  fileUrl === null
                                    ? true
                                    : false || checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions)
                                }
                                href={fileUrl}
                                target="_blank"
                              >
                                <Tooltip title="W-9">
                                  <ArrowCircleDownOutlinedIcon />
                                </Tooltip>
                              </Button>
                            </Stack>
                          </TableCell>
                          <TableCell align="left">
                            <Stack direction="row" justifyContent={'center'}>
                              <Button
                                style={{
                                  textDecoration: 'none',
                                  color:
                                    contractFileUrl === null ||
                                    checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions)
                                      ? 'lightgray'
                                      : 'blue',
                                  border: 'none',
                                  background: 'none',
                                }}
                                disabled={
                                  contractFileUrl === null
                                    ? true
                                    : false || checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions)
                                }
                                href={contractFileUrl}
                                target="_blank"
                              >
                                <Tooltip title="Contract">
                                  <ArrowCircleDownOutlinedIcon />
                                </Tooltip>
                              </Button>
                            </Stack>
                          </TableCell> */}
                          <TableCell align="center">
                            <Tooltip title="Reset Password">
                            <IconButton
                              onClick={() => handleClickChanges(emailId)}
                              style={{ color: '#E23744' }}
                            >
                              <LockResetIcon />
                            </IconButton>
                          </Tooltip>
                          </TableCell>
                          {/* <TableCell align="left">
                            <Button
                              style={{ color: 'white', backgroundColor: '#E23744' }}
                              variant="contained"
                              disabled={isStripeOnboarded}
                              onClick={() => handleClickSendLink(id)}
                            >
                              Send Link
                            </Button>
                          </TableCell> */}
                          <TableCell>
                            <Stack direction="row" justifyContent={'center'}>
                              <Switch
                                disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions)}
                                checked={status}
                                onClick={() => {
                                  setVendorId(id);
                                  handleOpen();
                                }}
                              />
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={12} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={serviceProviderTotalRecords || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        {open && (
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" textAlign={'center'} variant="h4" gutterBottom>
                Are you sure?
              </Typography>
              <Stack direction="row" justifyContent={'center'} alignItems={'center'}>
                <Button variant="contained" onClick={cancelDelete} sx={{ margin: '10px' }} style={{color: 'white', backgroundColor: '#E23744'}}>
                  No
                </Button>
                <Button variant="contained" onClick={handleDelete} sx={{ margin: '10px' }} style={{color: 'white', backgroundColor: '#E23744'}}>
                  Yes
                </Button>
              </Stack>
            </Box>
          </Modal>
        )}
        {serviceProviderResponse.isLoading || deleteResponse.isLoading ? <Loading /> : null}
      </Container>
      {/* ):null} */}
    </Page>
  );
}
